import React, {ComponentProps} from "react";
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {CloseIconButton} from "../../../../atoms/CloseIconButton";
import {useAppSelector} from "../../../../store/hooks";
import {SidebarTestContainer} from "../../lead_sidebar/SidebarTestContainer";
import {AskForFullOfferForm} from "./AskForFullOfferForm";

type IProps = Omit<ComponentProps<typeof AskForFullOfferForm>, "customHeader">;

export const LeadModalAskForFullOfferForm = (props: IProps) => {
    const {handleModalClose} = props;
    const vendor = useAppSelector((state) => state.application[props.storeHash || 0]?.vendor?.detail);

    return (
        <div className={containerStyles}>
            <div className={innerContainerStyles}>
                <CloseIconButton className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

                <AskForFullOfferForm
                    {...props}
                    customHeader={
                        <SidebarTestContainer>
                            {[
                                () => (
                                    <Text variant="headline_4" as="p" mb={3} align="center">
                                        Zapytaj dewelopera o pełną ofertę
                                    </Text>
                                ),
                                () => (
                                    <div className={vendorInfoWrapper}>
                                        {vendor ? (
                                            <>
                                                <Image
                                                    width="80px"
                                                    height="60px"
                                                    alt="zdjęcie konsultanta"
                                                    src={vendor.logo?.v_log_80x60}
                                                    className={imgStyle}
                                                />
                                                <div>
                                                    <Text variant="headline_6" as="p" strong>
                                                        Zapytaj o pełną ofertę
                                                    </Text>
                                                    <Text variant="body_copy_2">{vendor.name}</Text>
                                                </div>
                                            </>
                                        ) : (
                                            <Loader />
                                        )}
                                    </div>
                                )
                            ]}
                        </SidebarTestContainer>
                    }
                    isTwoColumnGrid
                />
            </div>
        </div>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});

const innerContainerStyles = css({
    p: 3
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});

const vendorInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    gap: 2,
    justifyContent: "start",
    alignItems: "center",
    mb: 3,
    mr: 4
});

const imgStyle = css({
    minHeight: "60px",
    minWidth: "80px"
});
import React, {ComponentProps} from "react";
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {CloseIconButton} from "../../../../atoms/CloseIconButton";
import {useAppSelector} from "../../../../store/hooks";
import {SidebarTestContainer} from "../../lead_sidebar/SidebarTestContainer";
import {AskForFullOfferForm} from "./AskForFullOfferForm";

type IProps = Omit<ComponentProps<typeof AskForFullOfferForm>, "customHeader">;

export const LeadModalAskForFullOfferForm = (props: IProps) => {
    const {handleModalClose} = props;
    const vendor = useAppSelector((state) => state.application[props.storeHash || 0]?.vendor?.detail);

    return (
        <div className={containerStyles}>
            <div className={innerContainerStyles}>
                <CloseIconButton className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

                <AskForFullOfferForm
                    {...props}
                    customHeader={
                        <SidebarTestContainer>
                            {[
                                () => (
                                    <Text variant="headline_4" as="p" mb={3} align="center">
                                        Zapytaj dewelopera o pełną ofertę
                                    </Text>
                                ),
                                () => (
                                    <div className={vendorInfoWrapper}>
                                        {vendor ? (
                                            <>
                                                <Image
                                                    width="80px"
                                                    height="60px"
                                                    alt="zdjęcie konsultanta"
                                                    src={vendor.logo?.v_log_80x60}
                                                    className={imgStyle}
                                                />
                                                <div>
                                                    <Text variant="headline_6" as="p" strong>
                                                        Zapytaj o pełną ofertę
                                                    </Text>
                                                    <Text variant="body_copy_2">{vendor.name}</Text>
                                                </div>
                                            </>
                                        ) : (
                                            <Loader />
                                        )}
                                    </div>
                                )
                            ]}
                        </SidebarTestContainer>
                    }
                    isTwoColumnGrid
                />
            </div>
        </div>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});

const innerContainerStyles = css({
    p: 3
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});

const vendorInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    gap: 2,
    justifyContent: "start",
    alignItems: "center",
    mb: 3,
    mr: 4
});

const imgStyle = css({
    minHeight: "60px",
    minWidth: "80px"
});
